export const preventLinkRedirect = (event, prevented) => {
  if (prevented) event.preventDefault();
};
